// import Swiper from 'swiper';

const CarouselBannerHome = document.querySelector('.home-banner__swiper');

if (CarouselBannerHome) {
  var bannerHome = new Swiper('.home-banner__swiper', {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    slidesPerView: 1,
    //freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init() {
        var slidesVideo = document.querySelectorAll('.slide-video');
        for (var elSlideVideo of slidesVideo) {
          var video = elSlideVideo.querySelector('video');

          video.addEventListener('loadeddata', verDuracaoVideo);

          function verDuracaoVideo() {
            var duracaoVideo = video.duration * 1000;
            // console.log(video.duration);
            elSlideVideo.setAttribute('data-swiper-autoplay', duracaoVideo);
            bannerHome.update();
          }
        }

        const activeSlide = this.slides[this.activeIndex];

        var slidesVideo = CarouselBannerHome.querySelectorAll('.slide-video');

        for (var slide of this.slides) {
          if (activeSlide.querySelector('video')) {
            var videos = activeSlide.querySelectorAll('video');
            for (var elVideo of videos) {
              elVideo.play();
            }
          } else {
            for (var elSlideVideo of slidesVideo) {
              var videoDesk = elSlideVideo.querySelectorAll('video');
              for (var elVideo of videoDesk) {
                elVideo.pause();
                elVideo.currentTime = 0;
              }
            }
          }
        }
      },
      slideChange() {
        const activeSlide = this.slides[this.activeIndex];

        var slidesVideo = CarouselBannerHome.querySelectorAll('.slide-video');

        for (var slide of this.slides) {
          if (activeSlide.querySelector('video')) {
            var videos = activeSlide.querySelectorAll('video');
            for (var elVideo of videos) {
              elVideo.play();
            }
          } else {
            for (var elSlideVideo of slidesVideo) {
              var videoDesk = elSlideVideo.querySelectorAll('video');
              for (var elVideo of videoDesk) {
                elVideo.pause();
                elVideo.currentTime = 0;
              }
            }
          }
        }
      },

      autoplayStop() {
        // console.log("parou");
      },
    },
  });
}

const CarouselMarcasHome = document.querySelector('.marcas__swiper');

if (CarouselMarcasHome) {
  var marcasHome = new Swiper('.marcas__swiper', {
    spaceBetween: 15,
    slidesPerView: 'auto',
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.marcas .swiper-button-next',
      prevEl: '.marcas .swiper-button-prev',
    },
    pagination: {
      el: '.marcas .swiper-pagination',
      type: 'bullets',
    },
  });
}

const CarouselSustentabilidadeInfograficoNovo = document.querySelector('.swiper-sustentabilidade-infograficonovo');

if (CarouselSustentabilidadeInfograficoNovo) {
  var InfograficoNovo = new Swiper('.swiper-sustentabilidade-infograficonovo', {
    spaceBetween: 15,
    slidesPerView: 'auto',
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.button-infograficonovo',
      prevEl: '.swiper-button-prev.button-infograficonovo',
    },
    pagination: {
      el: '.swiper-pagination.pagination-infograficonovo',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + '.</span>';
      },
    },
  });
}

const CarouselNewsHome = document.querySelector('.news__swiper');

if (CarouselNewsHome) {
  var newsHome = new Swiper('.news__swiper', {
    spaceBetween: 15,
    slidesPerView: 'auto',
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: ".home-blog__carrossel .swiper-button-next",
      prevEl: ".home-blog__carrossel .swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: '4',
      },
    },
    pagination: {
      el: '.news__swiper .swiper-pagination',
      type: 'bullets',
    },
  });
}

const CarouselNewsHomeBT = document.querySelector('.beleza-transparente-content .news__swiper');

if (CarouselNewsHomeBT) {
  var newsHome = new Swiper('.beleza-transparente-content .news__swiper', {
    spaceBetween: 15,
    slidesPerView: '1.5',
    centerInsufficientSlides: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    // freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.home-blog__carrossel .swiper-button-next',
      prevEl: '.home-blog__carrossel .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: '4',
      },
    },
  });
}

const CarouselProjetos = document.querySelector('.projetos__swiper');

if (CarouselProjetos) {
  var newsHome = new Swiper('.projetos__swiper', {
    spaceBetween: 15,
    slidesPerView: '1.3',
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.home-blog__carrossel .swiper-button-next',
      prevEl: '.home-blog__carrossel .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: '2.5',
      },
    },
  });
}

const CarouselVideosHome = document.querySelector('.home-videos__swiper');

if (CarouselVideosHome) {
  var videosHome = new Swiper('.home-videos__swiper', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    centerInsufficientSlides: true,
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.home-videos .swiper-button-next',
      prevEl: '.home-videos .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        centeredSlides: false,
        centerInsufficientSlides: false,
      },
    },
  });
}

const CarouselLiderancasSobre = document.querySelector('.sobre-liderancas__panel--conselho .sobre-liderancas__swiper');

if (CarouselLiderancasSobre) {
  var liderancasSobre = new Swiper('.sobre-liderancas__panel--conselho .sobre-liderancas__swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    //freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    autoHeight: true,
    navigation: {
      nextEl: '.sobre-liderancas__panel--conselho .swiper-button-next',
      prevEl: '.sobre-liderancas__panel--conselho .swiper-button-prev',
    },
    pagination: {
      el: '.sobre-liderancas__panel--conselho .swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return current + ' de ' + total;
      },
    },
  });
}

const CarouselLiderancasSobreVPs = document.querySelector('.sobre-liderancas__panel--vps .sobre-liderancas__swiper');

if (CarouselLiderancasSobreVPs) {
  var liderancasSobreVPs = new Swiper('.sobre-liderancas__panel--vps .sobre-liderancas__swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    //freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    autoHeight: true,
    navigation: {
      nextEl: '.sobre-liderancas__panel--vps .swiper-button-next',
      prevEl: '.sobre-liderancas__panel--vps .swiper-button-prev',
    },
    pagination: {
      el: '.sobre-liderancas__panel--vps .swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return current + ' de ' + total;
      },
    },
  });
}

const CarouselLiderancasSobreFundador = document.querySelector('.sobre-liderancas__panel--fundador .sobre-liderancas__swiper');

if (CarouselLiderancasSobreFundador) {
  var liderancasSobreFundador = new Swiper('.sobre-liderancas__panel--fundador .sobre-liderancas__swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    //freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    autoHeight: true,
    navigation: {
      nextEl: '.sobre-liderancas__panel--fundador .swiper-button-next',
      prevEl: '.sobre-liderancas__panel--fundador .swiper-button-prev',
    },
    pagination: {
      el: '.sobre-liderancas__panel--fundador .swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return current + ' de ' + total;
      },
    },
  });
}

const CarouselLiderancasSobrePresidente = document.querySelector('.sobre-liderancas__panel--presidente .sobre-liderancas__swiper');

if (CarouselLiderancasSobrePresidente) {
  var liderancasSobrePresidente = new Swiper('.sobre-liderancas__panel--presidente .sobre-liderancas__swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    //freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    autoHeight: true,
    navigation: {
      nextEl: '.sobre-liderancas__panel--presidente .swiper-button-next',
      prevEl: '.sobre-liderancas__panel--presidente .swiper-button-prev',
    },
    pagination: {
      el: '.sobre-liderancas__panel--presidente .swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return current + ' de ' + total;
      },
    },
  });
}

const CarouselBelezaTransparenteParcerias = document.querySelector('.belezatransparente-carrosselparcerias__swiper');

if (CarouselBelezaTransparenteParcerias) {
  var carrosselParcerias = new Swiper('.belezatransparente-carrosselparcerias__swiper', {
    slidesPerView: 1,
    spaceBetween: 15,
    autoHeight: true,
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: '.belezatransparente-carrosselparcerias .swiper-button-next',
      prevEl: '.belezatransparente-carrosselparcerias .swiper-button-prev',
    },
    breakpoints: {
      768: {
        autoHeight: false,
        slidesPerView: 2.8,
      },
    },
    pagination: {
      el: '.belezatransparente-carrosselparcerias .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
}

var allCarrosselAbas = document.querySelectorAll('.home-beleza'); //seleciona todos os blocos de carrossel com abas
if (allCarrosselAbas) {
  for (elCarrosselAbas of allCarrosselAbas) {
    var nCarrosselAbas = Array.prototype.indexOf.call(allCarrosselAbas, elCarrosselAbas);
    var CarouselNavBelezaHome = elCarrosselAbas.querySelector('.home-beleza__swiper');

    if (CarouselNavBelezaHome) {
      var belezaNavHome = new Swiper(CarouselNavBelezaHome, {
        spaceBetween: 0,
        slidesPerView: 'auto',
        // centeredSlides: true,
        slideToClickedSlide: true,
        // breakpoints: {
        //   768: { //desk
        //     slidesPerView: "auto",
        // centeredSlides: true,
        // slideToClickedSlide: true,
        //   },
        // },
      });
    }

    var CarouselBelezaHome = elCarrosselAbas.querySelector('.home-beleza__panels');

    // var CarouselBelezaHomeSetasNext = CarouselBelezaHome.querySelector(".swiper-button-next");
    // var CarouselBelezaHomeSetasPrev = CarouselBelezaHome.querySelector(".swiper-button-prev");
    // var CarouselBelezaHomeSetasNextTopo = CarouselBelezaHome.nextSibling.querySelector(".home-beleza__arrows .swiper-button-next");
    // var CarouselBelezaHomeSetasPrevTopo = CarouselBelezaHome.nextSibling.querySelector(".home-beleza__arrows .swiper-button-prev");

    // for (CarouselBelezaHomeSetaNext of CarouselBelezaHomeSetasNext) {
    //   CarouselBelezaHomeSetaNext.classList.add("swiper-button-next-" + i);
    // }

    // for (CarouselBelezaHomeSetaNextTopo of CarouselBelezaHomeSetasNextTopo) {
    //   CarouselBelezaHomeSetaNextTopo.classList.add("swiper-button-next-" + i);
    // }

    // for (CarouselBelezaHomeSetaPrev of CarouselBelezaHomeSetasPrev) {
    //   CarouselBelezaHomeSetaPrev.classList.add("swiper-button-prev-" + i);
    // }

    // for (CarouselBelezaHomeSetaPrevTopo of CarouselBelezaHomeSetasPrevTopo) {
    //   CarouselBelezaHomeSetaPrevTopo.classList.add("swiper-button-prev-" + i);
    // }

    if (CarouselBelezaHome) {
      var belezaHome = new Swiper(CarouselBelezaHome, {
        spaceBetween: 10,
        slidesPerView: 1,
        //freeMode: true,
        // watchSlidesVisibility: true,
        // watchSlidesProgress: true,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        autoHeight: true,
        // keyboard: {
        //   enabled: true,
        //   onlyInViewport: false,
        // },
        thumbs: {
          swiper: belezaNavHome,
        },
        navigation: {
          nextEl: allCarrosselAbas[nCarrosselAbas].querySelector('.swiper-button-next'),
          prevEl: allCarrosselAbas[nCarrosselAbas].querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: allCarrosselAbas[nCarrosselAbas].querySelector('.swiper-pagination'),
          type: 'bullets',
        },
      });
    }
  }
}

const CarouselBelezaTransparenteIT = document.querySelector('.belezatransparente-carrosselit__swiper');

if (CarouselBelezaTransparenteIT) {
  var newsHome = new Swiper('.belezatransparente-carrosselit__swiper', {
    spaceBetween: 15,
    slidesPerView: 1,
    autoHeight: false,
    navigation: {
      nextEl: ".belezatransparente-carrosselit .swiper-button-next",
      prevEl: ".belezatransparente-carrosselit .swiper-button-prev",
    },
    pagination: {
      el: '.belezatransparente-carrosselit .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
}

const CarouselImagemTextoNovo = document.querySelectorAll('.belezatransparente-carrosselitnovo__swiper');

if (CarouselImagemTextoNovo) {
  for (var [i, elCarouselImagemTextoNovo] of CarouselImagemTextoNovo.entries()) {
    var CarouselImagemTextoNovoSetasNext = elCarouselImagemTextoNovo.querySelectorAll('.belezatransparente-carrosselitnovo__arrows .swiper-button-next');
    var CarouselImagemTextoNovoSetasPrev = elCarouselImagemTextoNovo.querySelectorAll('.belezatransparente-carrosselitnovo__arrows .swiper-button-prev');

    for (CarouselImagemTextoNovoSetaNext of CarouselImagemTextoNovoSetasNext) {
      CarouselImagemTextoNovoSetaNext.classList.add('swiper-button-next-' + i);
    }

    for (CarouselImagemTextoNovoSetaPrev of CarouselImagemTextoNovoSetasPrev) {
      CarouselImagemTextoNovoSetaPrev.classList.add('swiper-button-prev-' + i);
    }
    var galeriaSustentabilidade = new Swiper(elCarouselImagemTextoNovo, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      autoHeight: false,
      loop: true,
      navigation: {
        nextEl: '.belezatransparente-carrosselitnovo__arrows .swiper-button-next.swiper-button-next-' + i,
        prevEl: '.belezatransparente-carrosselitnovo__arrows .swiper-button-prev.swiper-button-prev-' + i,
      },
      pagination: {
        el: '.belezatransparente-carrosselitnovo__pagination',
        clickable: true,
      },
    });
  }
}
const CarouselModalPopUp = document.querySelectorAll('.carrosselmodal__swiper');

if (CarouselModalPopUp.length > 0) {
  for (let [i, elCarouselModalPopUp] of CarouselModalPopUp.entries()) {
    const CarouselModalPopUpSetasNext = elCarouselModalPopUp.parentNode.querySelector('.swiper-button-next');
    const CarouselModalPopUpSetasPrev = elCarouselModalPopUp.parentNode.querySelector('.swiper-button-prev');

    CarouselModalPopUpSetasNext.classList.add('swiper-button-next-' + i);
    CarouselModalPopUpSetasPrev.classList.add('swiper-button-prev-' + i);

    new Swiper(elCarouselModalPopUp, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      autoHeight: false,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next-' + i,
        prevEl: '.swiper-button-prev-' + i,
      },
      pagination: {
        el: '.carrosselmodal__pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 3,
        },
        1220: {
          slidesPerView: 4,
        }
      }
    });
  }
}

/*==BLOCO MODAL (BOTÃO)===*/
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.carrosselmodal__btn');
  const overlay = document.getElementById('overlayModal');

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const modalId = button.getAttribute('data-modal');
      const modal = document.getElementById(modalId);

      const allModals = document.querySelectorAll('.carrosselmodal__modal');
      allModals.forEach(mod => {
        mod.close();
      });

      modal.showModal();
      overlay.style.display = 'block';
    });
  });

  function closeModal(modal) {
    modal.close();
    overlay.style.display = 'none';
  }

  const closeButtons = document.querySelectorAll('.btn-close');
  closeButtons.forEach(closeButton => {
    closeButton.addEventListener('click', function () {
      const modal = closeButton.closest('dialog');
      closeModal(modal);
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      const openModal = document.querySelector('dialog[open]');
      if (openModal) {
        closeModal(openModal);
      }
    });
  }
});

const carrosseis = document.querySelectorAll('.carrossel-full');

carrosseis.forEach((carousel, index) => {
  const swiperContainer = carousel.querySelector('.carrossel-full__swiper');
  const prevButton = carousel.querySelector('.swiper-button-prev');
  const nextButton = carousel.querySelector('.swiper-button-next');
  const pagination = swiperContainer.querySelector('.swiper-pagination');

  new Swiper(swiperContainer, {
    slidesPerView: 1,
    autoHeight: false,
    effect: 'fade',
    autoplay: {
      delay: 10000,
    },
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    pagination: {
      el: pagination,
      clickable: true,
    },
  });
});

const carouselDepoimentos = document.querySelectorAll('.carrossel-depoimentos__swiper');

if (carouselDepoimentos) {
  for (var [i, elcarouselDepoimentos] of carouselDepoimentos.entries()) {

    var carrosselDepoimentos = new Swiper(elcarouselDepoimentos, {

      slidesPerView: 1.2,
      // slidesPerView: 2.3,
      spaceBetween: 20,
      centeredSlides: true,
      autoHeight: true,
      grabCursor: true,
      // loop: true,
      autoplay: {
        enabled: false,
      },
      breakpoints: {
        768: {
          mousewheel: {
            invert: false,
          },
          spaceBetween: 80,
          slidesPerView: 'auto',
          autoHeight: false,
          speed: 18000,
          freeMode: true,
          autoplay: {
            enabled: true,
            delay: 0,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          },
        },
      },
    });
  }
}

// const CarouselNavBelezaHome = document.querySelector(".home-beleza__swiper");

// if (CarouselNavBelezaHome) {
//   var belezaNavHome = new Swiper(".home-beleza__swiper", {
//     spaceBetween: 0,
//     slidesPerView: "auto",
//     //freeMode: true,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
//     observer: true,
//     observeParents: true,
//     watchSlidesProgress: true,
//     centeredSlides: true,
//     breakpoints: {
//       768: {
//         slidesPerView: "auto",
//         centeredSlides: false,
//       },
//     },
//   });
// }

// const CarouselBelezaHome = document.querySelector(".home-beleza__panels");

// if (CarouselBelezaHome) {
//   var belezaHome = new Swiper(".home-beleza__panels", {
//     spaceBetween: 10,
//     slidesPerView: 1,
//     //freeMode: true,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
//     // centeredSlides: true,
//     observer: true,
//     observeParents: true,
//     autoHeight: true,
//     keyboard: {
//       enabled: true,
//       onlyInViewport: false,
//     },
//     thumbs: {
//       swiper: belezaNavHome,
//     },
//     navigation: {
//       nextEl: ".home-beleza .swiper-button-next",
//       prevEl: ".home-beleza .swiper-button-prev",
//     },
//     pagination: {
//       el: ".home-beleza .swiper-pagination",
//       type: "custom",
//       renderCustom: function (swiper, current, total) {
//         return current + " de " + total;
//       },
//     },
//   });
// }


const CarouselDepoimentosCarreiras = document.querySelector('.carreiras-depoimentos__swiper');

if (CarouselDepoimentosCarreiras) {
  var liderancasSobre = new Swiper('.carreiras-depoimentos__swiper', {
    spaceBetween: 16,
    slidesPerView: 1,
    //freeMode: true,
    autoHeight: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.carreiras-depoimentos .swiper-button-next',
      prevEl: '.carreiras-depoimentos .swiper-button-prev',
    },
    pagination: {
      el: '.carreiras-depoimentos .swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return current + ' de ' + total;
      },
    },
  });
}

var allCarouselProgramasCarreiras = document.querySelectorAll('.carreiras-programas');
const CarouselProgramasCarreiras = document.querySelector('.carreiras-programas__swiper');

if (CarouselProgramasCarreiras) {
  for (var elCarouselProgramasCarreiras of allCarouselProgramasCarreiras) {
    // console.log(allCarouselProgramasCarreiras);
    // Array.prototype.indexOf.call(haystack, needle);
    var nCarouselProgramasCarreiras = Array.prototype.indexOf.call(allCarouselProgramasCarreiras, elCarouselProgramasCarreiras);

    var carousel = elCarouselProgramasCarreiras.querySelector('.carreiras-programas__swiper');
    var programasCarreiras = new Swiper(carousel, {
      autoplay: {
        delay: 10000,
      },
      spaceBetween: 15,
      slidesPerView: 1,
      //freeMode: true,
      autoHeight: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: allCarouselProgramasCarreiras[nCarouselProgramasCarreiras].querySelector('.swiper-button-next'),
        prevEl: allCarouselProgramasCarreiras[nCarouselProgramasCarreiras].querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: allCarouselProgramasCarreiras[nCarouselProgramasCarreiras].querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      breakpoints: {
        768: {
          autoHeight: false,
        },
      },
    });
  }

  // var programasCarreiras = new Swiper('.carreiras-programas__swiper', {
  //   autoplay: {
  //    delay: 10000,
  //  },
  //   spaceBetween: 15,
  //   slidesPerView: 1,
  //   //freeMode: true,
  //   autoHeight: true,
  //   watchSlidesVisibility: true,
  //   watchSlidesProgress: true,
  //   observer: true,
  // observeParents: true,
  //   navigation: {
  //     nextEl: '.carreiras-programas .swiper-button-next',
  //     prevEl: '.carreiras-programas .swiper-button-prev',
  //   },
  //   pagination: {
  //           el: ".carreiras-programas .swiper-pagination",
  //           clickable: true,
  //           renderBullet: function (index, className) {
  //             return '<span class="' + className + '">' + (index + 1) + "</span>";
  //           },
  //         },
  //   breakpoints: {
  //     768: {
  //       autoHeight: false,
  //     },
  //   }

  // });
}

const CarouselMarcasContato = document.querySelector('.contato-marcas__swiper');

if (CarouselMarcasContato) {
  (function () {
    'use strict';

    // breakpoint where swiper will be destroyed
    // and switches to a dual-column layout
    const breakpoint = window.matchMedia('(min-width:768px)');

    // keep track of swiper instances to destroy later
    let mySwiper;

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    const breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches === true) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) mySwiper.destroy(true, true);

        // or/and do nothing
        return;

        // else if a small viewport and single column layout needed
      } else if (breakpoint.matches === false) {
        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    //////////////////////////////////////////////////////////////////

    const enableSwiper = function () {
      mySwiper = new Swiper('.contato-marcas__swiper', {
        spaceBetween: 15,

        loop: false,

        slidesPerView: 'auto',

        // navigation: {
        //   nextEl: ".contato-marcas .swiper-button-next",
        //   prevEl: ".contato-marcas .swiper-button-prev",
        // },

        // breakpoints: {
        //   768: {

        //   },
        // }

        pagination: {
          el: '.contato-marcas__grid .swiper-pagination',
          type: 'bullets',
        },
      });
    };

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  })(); /* IIFE end */
}

const CarouselMarcasEcossistema = document.querySelector('.ecossistema-marcas__swiper');

if (CarouselMarcasEcossistema) {
  var marcasEcossistema = new Swiper('.ecossistema-marcas__swiper', {
    // spaceBetween: 15,
    slidesPerView: 'auto',
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.ecossistema-marcas .swiper-button-next',
      prevEl: '.ecossistema-marcas .swiper-button-prev',
    },
    pagination: {
      el: '.ecossistema-marcas .swiper-pagination',
      type: 'bullets',
    },
  });
}

const CarouselProjetosSustentabilidade = document.querySelector('.sustentabilidade-projetos__swiper');

if (CarouselProjetosSustentabilidade) {
  var projetosSustentabilidade = new Swiper('.sustentabilidade-projetos__swiper', {
    // spaceBetween: 15,
    slidesPerView: 'auto',
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,

    navigation: {
      nextEl: '.sustentabilidade-projetos__arrows .swiper-button-next',
      prevEl: '.sustentabilidade-projetos__arrows .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
  });
}

const CarouselNavSustentabilidade = document.querySelector('.sustentabilidade-thumb__swiper');

if (CarouselNavSustentabilidade) {
  var navSustentabilidade = new Swiper('.sustentabilidade-thumb__swiper', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    //freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      768: {
        slidesPerView: 4,
      },
    },
  });
}

const CarouselGaleriaSustentabilidade = document.querySelector('.sustentabilidade-galeria__swiper');

if (CarouselGaleriaSustentabilidade) {
  var galeriaSustentabilidade = new Swiper('.sustentabilidade-galeria__swiper', {
    // spaceBetween: 15,
    slidesPerView: 1,
    autoHeight: true,
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    thumbs: {
      swiper: navSustentabilidade,
    },
    navigation: {
      nextEl: '.sustentabilidade-galeria__arrows .swiper-button-next',
      prevEl: '.sustentabilidade-galeria__arrows .swiper-button-prev',
    },
    pagination: {
      el: '.sustentabilidade-galeria__pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return current + ' de ' + total;
      },
    },
  });
}

const carrosselMidia = document.querySelector('.carrossel-midia__swiper');

if (carrosselMidia) {
  var carrosselBlockMidia = new Swiper('.carrossel-midia__swiper', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.carrossel-midia__nav .swiper-button-next',
      prevEl: '.carrossel-midia__nav .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });
}

const carrosselAudio = document.querySelector('.carrossel-audio__swiper');

if (carrosselAudio) {
  var carrosselBlockAudio = new Swiper('.carrossel-audio__swiper', {
    spaceBetween: 0,
    slidesPerView: 1,
    // //freeMode: true,
    // watchSlidesVisibility: true,
    // watchSlidesProgress: true,
    navigation: {
      nextEl: '.carrossel-audio__nav .swiper-button-next',
      prevEl: '.carrossel-audio__nav .swiper-button-prev',
    },
    breakpoints: {
      480: {
        spaceBetween: 10,
        slidesPerView: 'auto',
      },
    },
  });
}

const carrosselSucessos = document.querySelector('.carrossel-sucessos__swiper');

if (carrosselSucessos) {
  var carrosselBlockSucessos = new Swiper('.carrossel-sucessos__swiper', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.carrossel-sucessos__nav .swiper-button-next',
      prevEl: '.carrossel-sucessos__nav .swiper-button-prev',
    },
  });
}

// Botão voltar - menu flutuante
function voltarPagina() {
  window.history.back();
}

// Menu

const hamburger = document.querySelector('.hamburger');
const navMain = document.querySelector('.nav');

hamburger.addEventListener('click', function () {
  hamburger.classList.toggle('is-active');
  navMain.classList.toggle('is-active');
  document.body.classList.toggle('menu-active');
});

/*
 * Bootstrap Cookie Alert by Wruczek
 * https://github.com/Wruczek/Bootstrap-Cookie-Alert
 * Released under MIT license
 */
(function () {
  'use strict';

  var cookieAlert = document.getElementById('cookiealert');
  var acceptCookies = document.getElementById('acceptcookies');

  if (!cookieAlert) {
    return;
  }

  cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

  // Show the alert if we cant find the "acceptCookies" cookie
  if (!getCookie('acceptCookies')) {
    cookieAlert.classList.add('show');
  }

  // When clicking on the agree button, create a 1 year
  // cookie to remember user's choice and close the banner
  acceptCookies.addEventListener('click', function () {
    setCookie('acceptCookies', true, 365);
    cookieAlert.classList.remove('show');
  });

  // Cookie functions from w3schools
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
})();

/*==ACORDEONS==*/

var details = document.querySelectorAll('.home-pilares__accordeon details');

if (details) {
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', () => {
      // Close all the details that are not targetDetail.
      details.forEach(detail => {
        if (detail !== targetDetail) {
          detail.removeAttribute('open');
        }
      });
    });
  });
}

const CarouselTimeline = document.querySelector('[data-carousel="timeline"]');

if (CarouselTimeline) {
  const Timeline = new Swiper(CarouselTimeline, {
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    navigation: {
      nextEl: '.sobre-timeline .swiper-button-next',
      prevEl: '.sobre-timeline .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
      },
    },
    // pagination: {
    //   el: HomeCarouselConteudos.querySelector('.swiper-pagination'),
    //   type: 'bullets',
    //   renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
    //   </button>`,
    //   clickable: true
    // },
  });
}

/*==select internacional==*/

var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName('custom-select');
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName('select')[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement('DIV');
  a.setAttribute('class', 'select-selected');
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement('DIV');
  b.setAttribute('class', 'select-items select-hide');
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement('DIV');
    /*==nat==*/
    c.setAttribute('data-value', selElmnt.options[j].value); /*ok*/
    /*==fim nat==*/
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener('click', function (e) {
      /* When an item is clicked, update the original select box,
      and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName('select')[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName('same-as-selected');
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute('class');
          }
          this.setAttribute('class', 'same-as-selected');
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener('click', function (e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle('select-hide');
    this.classList.toggle('select-arrow-active');
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName('select-items');
  y = document.getElementsByClassName('select-selected');
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove('select-arrow-active');
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('select-hide');
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener('click', closeAllSelect);

var ttlFooter = document.querySelectorAll('.footer__links h3');

for (var elTtlFooter of ttlFooter) {
  elTtlFooter.addEventListener('click', toggleLinkFooter);
}

function toggleLinkFooter() {
  event.target.nextElementSibling.classList.toggle('active');
}

var submenuHeader = document.querySelectorAll('.nav__mais span');
// var boxSubmenu = document.querySelectorAll('.nav__box-submenu');

for (var elSubmenuHeader of submenuHeader) {
  elSubmenuHeader.addEventListener('click', toggleSubmenu);
}

function toggleSubmenu() {
  // console.log(event.target)
  // event.target.nextElementSibling.classList.toggle('active');
  event.target.closest('.link-submenu').querySelector('.nav__box-submenu').classList.toggle('active');
}

/*==BLOCO LIDERANÇA==*/

var tabsLideranca = document.querySelectorAll('.sobre-liderancas__tab');
var panelsLideranca = document.querySelectorAll('.sobre-liderancas__panel');

if (tabsLideranca) {
  for (var elTabsLideranca of tabsLideranca) {
    elTabsLideranca.addEventListener('click', abrirPanelLideranca);
  }

  function abrirPanelLideranca() {
    for (var elTabsLideranca of tabsLideranca) {
      elTabsLideranca.classList.remove('active');
    }
    for (var elPanelsLideranca of panelsLideranca) {
      elPanelsLideranca.classList.remove('active');
    }
    var attrTabLideranca = event.target.getAttribute('data-tab-liderancas');
    document.querySelector('[data-panel-liderancas="' + attrTabLideranca + '"]').classList.add('active');
    event.target.classList.add('active');
  }
}

/*==BLOCO INTERNACIONAL==*/
var mapasIntDesk = document.querySelectorAll('.home-internacional__mapa--desk');
var mapasIntMobile = document.querySelectorAll('.home-internacional__mapa--mobile');
var txtInt = document.querySelectorAll('.home-internacional__pais');

var testListInternacional = document.querySelector('.home-internacional__opcoes');
var listInternacional = document.querySelectorAll('.home-internacional__opcoes button');

if (testListInternacional) {
  listInternacional[0].classList.add('active');
  mapasIntDesk[0].classList.add('active');
  mapasIntMobile[0].classList.add('active');
  txtInt[0].classList.add('active');

  for (var elListInternacional of listInternacional) {
    elListInternacional.addEventListener('click', selecionarPais);

    function selecionarPais() {
      var nPaisAtivo = Array.prototype.indexOf.call(listInternacional, event.target); //pega o index do item dentro do array

      for (var elMapasIntDesk of mapasIntDesk) {
        elMapasIntDesk.classList.remove('active');
      }

      for (var elMapasIntMobile of mapasIntMobile) {
        elMapasIntMobile.classList.remove('active');
      }

      for (var elTxtInt of txtInt) {
        elTxtInt.classList.remove('active');
      }

      for (var elListInternacional of listInternacional) {
        elListInternacional.classList.remove('active');
      }

      mapasIntDesk[nPaisAtivo].classList.add('active');
      mapasIntMobile[nPaisAtivo].classList.add('active');
      txtInt[nPaisAtivo].classList.add('active');
      listInternacional[nPaisAtivo].classList.add('active');
      // mapasIntMobile[nPaisAtivo].scrollIntoView({behavior: "smooth"});
      txtInt[nPaisAtivo].querySelector('.ancora').scrollIntoView({ behavior: 'smooth' });

      // console.log(event.target);
      // console.log(listInternacional);

      // event.target.classList.add('selecionado');
    }
  }

  var selectList = document.querySelectorAll('.home-internacional__select .select-items div');
  for (var elSelectList of selectList) {
    nElSelectList = Array.prototype.indexOf.call(selectList, elSelectList);
    elSelectList.id = 'mnu-escolha-um-pais-meio-' + nElSelectList;
    // console.log(Array.prototype.indexOf.call(selectList, elSelectList));
  }
  // var nPaisAtivo = Array.prototype.indexOf.call(listInternacional, event.target);
}

var btModal = document.querySelector('.home-videos__link');
var btsModal = document.querySelectorAll('.home-videos__link');
var btsFechar = document.querySelectorAll('.bt-close');
var allModal = document.querySelectorAll('.bg-video');
var btsNextModal = document.querySelectorAll('.modal-video__next');
var btsPrevModal = document.querySelectorAll('.modal-video__prev');
// var nModalAtivo;

if (btModal) {
  for (var elBtModal of btsModal) {
    if (elBtModal) {
      elBtModal.addEventListener('click', abrirModal);
    }

    for (var elBtFechar of btsFechar) {
      // console.log(btsFechar);
      elBtFechar.addEventListener('click', fecharModal);
    }
  }

  function abrirModal() {
    event.preventDefault();
    var nModalAtivo = event.target.closest('a').getAttribute('data-bt-video-home'); /*pega o atributo data-btmodal do target*/
    document.querySelector('[data-modal-video-home="' + nModalAtivo + '"]').classList.add('active');
    /*encontra qual modal tem o atributo data-modal igual ao data-btmodal do target e adiciona a classe active*/
  }

  function fecharModal() {
    for (var elModal of allModal) {
      elModal.classList.remove('active');

      var iframe = elModal.querySelector('iframe');
      var video = elModal.querySelector('video');
      var audio = elModal.querySelector('audio');
      if (iframe) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
      if (video) {
        video.pause();
      }
      if (audio) {
        audio.pause();
      }
    }
  }

  // console.log(btsNextModal);

  for (var elBtsNextModal of btsNextModal) {
    elBtsNextModal.addEventListener('click', nextModal);
  }
  function nextModal() {
    var modalAtivo = document.querySelector('.bg-video.active');
    var nModalAtivo = modalAtivo.getAttribute('data-modal-video-home');
    var nNextModal = parseInt(nModalAtivo) + 1;
    var totalModal = allModal.length + 1;
    for (var elBtsPrevModal of btsPrevModal) {
      elBtsPrevModal.classList.remove('inactive');
    }

    if (nNextModal == totalModal) {
      for (var elBtsNextModal of btsNextModal) {
        elBtsNextModal.classList.add('inactive');
      }
    } else {
      modalAtivo.querySelector('.modal-video__next').classList.remove('inactive');
      modalAtivo.classList.remove('active');
      document.querySelector('[data-modal-video-home="' + nNextModal + '"]').classList.add('active');
    }
    // modalAtivo
    // pegar atributo
    // atributo +1
    // pegar modal atributo +1
    // desativar modal ativo

    for (var elModal of allModal) {
      var iframe = elModal.querySelector('iframe');
      var video = elModal.querySelector('video');
      var audio = elModal.querySelector('audio');
      if (iframe) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
      if (video) {
        video.pause();
      }
      if (audio) {
        audio.pause();
      }
    }
  }

  for (var elBtsPrevModal of btsPrevModal) {
    elBtsPrevModal.addEventListener('click', prevModal);
  }
  function prevModal() {
    var modalAtivo = document.querySelector('.bg-video.active');
    var nModalAtivo = modalAtivo.getAttribute('data-modal-video-home');
    var nModalAtivo = parseInt(nModalAtivo) - 1;
    for (var elBtsNextModal of btsNextModal) {
      elBtsNextModal.classList.remove('inactive');
    }

    if (nModalAtivo == 0) {
      for (var elBtsPrevModal of btsPrevModal) {
        elBtsPrevModal.classList.add('inactive');
      }
    } else {
      modalAtivo.querySelector('.modal-video__prev').classList.remove('inactive');
      modalAtivo.classList.remove('active');
      document.querySelector('[data-modal-video-home="' + nModalAtivo + '"]').classList.add('active');
    }

    for (var elModal of allModal) {
      var iframe = elModal.querySelector('iframe');
      var video = elModal.querySelector('video');
      var audio = elModal.querySelector('audio');
      if (iframe) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
      if (video) {
        video.pause();
      }
      if (audio) {
        audio.pause();
      }
    }
  }
}
/*==download relatorios==*/

var relatorios = document.querySelector('.sustentabilidade-relatorios');

if (relatorios) {
  var allRelatorios = document.querySelectorAll('.sustentabilidade-relatorios .select-items div');

  for (var elRelatorio of allRelatorios) {
    var urlFile = elRelatorio.getAttribute('data-value'); /*pega o atributo data-btmodal do target*/
    var btDownload = document.createElement('a');
    btDownload.setAttribute('href', urlFile);
    btDownload.setAttribute('download', 'download');
    btDownload.setAttribute('target', '_blank');
    var indexFile = Array.prototype.indexOf.call(allRelatorios, elRelatorio);
    var idFile = 'btx-selecione-o-ano-' + indexFile;
    btDownload.setAttribute('id', idFile);
    elRelatorio.appendChild(btDownload);
    // btDownload.click();

    elRelatorio.addEventListener('click', downloadRelatorio);

    function downloadRelatorio() {
      // btDownload.click();
      event.target.querySelector('a').click();
      // console.log(event.target);
    }
  }
}

/*==BLOCO INOVAÇÃO==*/

var ifTabsInovacao = document.querySelector('.beleza-inovacao__tab');
var tabsInovacao = document.querySelectorAll('.beleza-inovacao__tab');
var panelsInovacao = document.querySelectorAll('.beleza-inovacao__panel');

if (ifTabsInovacao) {
  for (var elTabsInovacao of tabsInovacao) {
    elTabsInovacao.addEventListener('click', abrirPanelInovacao);
  }

  tabsInovacao[0].classList.add('active');
  panelsInovacao[0].classList.add('active');

  function abrirPanelInovacao() {
    for (var elTabsInovacao of tabsInovacao) {
      elTabsInovacao.classList.remove('active');
    }
    for (var elPanelsInovacao of panelsInovacao) {
      elPanelsInovacao.classList.remove('active');
    }
    var nTabAtiva = Array.prototype.indexOf.call(tabsInovacao, event.target); //pega o index do item dentro do array
    panelsInovacao[nTabAtiva].classList.add('active');
    event.target.classList.add('active');
    // var attrTabInovacao = event.target.getAttribute('data-tab-liderancas');
    // document.querySelector('[data-panel-liderancas="' + attrTabInovacao + '"]').classList.add('active');
    // event.target.classList.add('active');
  }
}

/*==INFOGRAFICO SUSTENTABILIDADE==*/

var menuInfografico = document.querySelectorAll('.sustentabilidade-infografico__menu li');
var imgsInfografico = document.querySelectorAll('.sustentabilidade-infografico__img');
var destaquesInfografico = document.querySelectorAll('.sustentabilidade-infografico__destaque');
var btFecharInfografico = document.querySelector('.sustentabilidade-infografico__close');

if (btFecharInfografico) {
  for (var elMenuInfografico of menuInfografico) {
    elMenuInfografico.addEventListener('click', abrirDestaque);
  }

  btFecharInfografico.addEventListener('click', fecharDestaque);

  function abrirDestaque() {
    for (var elMenuInfografico of menuInfografico) {
      elMenuInfografico.classList.remove('active');
    }
    for (var elImgsInfografico of imgsInfografico) {
      elImgsInfografico.classList.remove('active');
    }
    for (var elDestaquesInfografico of destaquesInfografico) {
      elDestaquesInfografico.classList.remove('active');
    }

    btFecharInfografico.classList.add('active');

    var nMenuAtivo = Array.prototype.indexOf.call(menuInfografico, event.target); //pega o index do item dentro do array
    // console.log(nMenuAtivo);
    menuInfografico[nMenuAtivo].classList.add('active');
    imgsInfografico[nMenuAtivo].classList.add('active');
    destaquesInfografico[nMenuAtivo].classList.add('active');
    document.querySelector('.sustentabilidade-infografico__ancora').scrollIntoView();
  }

  function fecharDestaque() {
    for (var elMenuInfografico of menuInfografico) {
      elMenuInfografico.classList.add('active');
    }
    for (var elImgsInfografico of imgsInfografico) {
      elImgsInfografico.classList.remove('active');
    }
    for (var elDestaquesInfografico of destaquesInfografico) {
      elDestaquesInfografico.classList.remove('active');
    }

    // menuInfografico[0].classList.add('active');
    imgsInfografico[0].classList.add('active');
    destaquesInfografico[0].classList.add('active');

    btFecharInfografico.classList.remove('active');
  }
}

/*==bloco carrossel video ==*/

var wrapperModalMidia = document.getElementById('all-midia');

if (wrapperModalMidia) {
  var btsVideosModal = document.querySelectorAll('.carrossel-midia__link img');
  var btsFechar = document.querySelectorAll('.bt-close');
  var allModalMidia = document.querySelectorAll('.bg-midia');

  document.body.append(wrapperModalMidia);

  for (var elBtVideosModal of btsVideosModal) {
    if (elBtVideosModal) {
      elBtVideosModal.addEventListener('click', abrirModalVideo);
    }

    for (var elBtFechar of btsFechar) {
      // console.log(btsFechar);
      elBtFechar.addEventListener('click', fecharModalVideo);
    }

    function abrirModalVideo() {
      event.preventDefault();
      var nMidiaAtiva = Array.prototype.indexOf.call(btsVideosModal, event.target); //pega o index do item dentro do array
      // console.log(nMidiaAtiva);
      for (var elModalMidia of allModalMidia) {
        elModalMidia.classList.remove('active');
      }

      allModalMidia[nMidiaAtiva].classList.add('active');

      /*encontra qual modal tem o atributo data-modal igual ao data-btmodal do target e adiciona a classe active*/
    }

    function fecharModalVideo() {
      for (var elModalMidia of allModalMidia) {
        elModalMidia.classList.remove('active');

        var iframe = elModalMidia.querySelector('iframe');
        var video = elModalMidia.querySelector('video');

        if (iframe) {
          var iframeSrc = iframe.src;
          iframe.src = iframeSrc;
        }

        if (video) {
          video.pause();
        }

        var audio = elModalMidia.querySelector('audio');
        // console.log(audio);

        if (audio) {
          audio.pause();
        }
      }
    }
  }
}

/*==bloco carrossel audio ==*/

var wrapperModalAudio = document.getElementById('all-audio');

if (wrapperModalAudio) {
  var btsAudioModal = document.querySelectorAll('.carrossel-audio__link img');
  var btsFecharAudio = document.querySelectorAll('.bt-close-audio');
  var allModalAudio = document.querySelectorAll('.bg-audio');

  document.body.append(wrapperModalAudio);

  for (var elBtAudioModal of btsAudioModal) {
    if (elBtAudioModal) {
      elBtAudioModal.addEventListener('click', abrirModalAudio);
    }

    for (var elBtFecharAudio of btsFecharAudio) {
      // console.log(btsFecharAudio);
      elBtFecharAudio.addEventListener('click', fecharModalAudio);
    }

    function abrirModalAudio() {
      event.preventDefault();
      var nAudioAtivo = Array.prototype.indexOf.call(btsAudioModal, event.target); //pega o index do item dentro do array
      // console.log(nAudioAtivo);
      for (var elModalAudio of allModalAudio) {
        elModalAudio.classList.remove('active');
      }

      allModalAudio[nAudioAtivo].classList.add('active');

      /*encontra qual modal tem o atributo data-modal igual ao data-btmodal do target e adiciona a classe active*/
    }

    function fecharModalAudio() {
      for (var elModalAudio of allModalAudio) {
        elModalAudio.classList.remove('active');

        var audio = elModalAudio.querySelector('audio');
        // console.log(audio);

        if (audio) {
          audio.pause();
        }
      }
    }
  }
}

/*==SEARCH==*/
var btBuscaMobile = document.getElementById('bt-search-mobile');
var wrapperBuscaMobile = document.getElementById('search-panel');
var btFecharBuscaMobile = document.getElementById('fechar-busca-mobile');

btBuscaMobile.addEventListener('click', abrirBuscaMobile);
btFecharBuscaMobile.addEventListener('click', fecharBuscaMobile);

function abrirBuscaMobile() {
  wrapperBuscaMobile.classList.add('active');
}

function fecharBuscaMobile() {
  wrapperBuscaMobile.classList.remove('active');
}

/*==SEARCH MOBILE==*/
var btBusca = document.getElementById('bt-search');
var wrapperBusca = document.getElementById('wrapper-busca');
var btFecharBusca = document.getElementById('fechar-busca');
var btMenuBusca = document.getElementById('menu-busca');

btBusca.addEventListener('click', abrirBusca);
btFecharBusca.addEventListener('click', fecharBusca);
btMenuBusca.addEventListener('click', fecharBusca);

function abrirBusca() {
  wrapperBusca.classList.add('active');
}

function fecharBusca() {
  wrapperBusca.classList.remove('active');
}

/*==MENU ACESSIBILIDADE==*/
var btA11y = document.querySelector('#a11y .a11y__btn');
var wrapperA11y = document.getElementById('a11y');
var btFecharA11y = document.querySelector('#a11y .a11y__close');

btA11y.addEventListener('click', abrirA11y);
btFecharA11y.addEventListener('click', fecharA11y);

function abrirA11y() {
  wrapperA11y.classList.add('active');
}

function fecharA11y() {
  wrapperA11y.classList.remove('active');
}

// Accessibility

sessionStorage.getItem('contrast') && +sessionStorage.getItem('contrast') && document.body.classList.add('has--high-contrast');

if (document.querySelector('[data-contrast]')) {
  document.querySelector('[data-contrast]').addEventListener(
    'click',
    () => {
      // console.log("contraste");
      document.body.classList.toggle('has--high-contrast');

      sessionStorage.setItem('contrast', document.body.classList.contains('has--high-contrast') ? 1 : 0);
    },
    true
  );
}

if (sessionStorage.getItem('fontsize')) document.body.style.fontSize = sessionStorage.getItem('fontsize') + 'px';

if (document.querySelector('[data-fontsize-decrease]')) {
  document.querySelector('[data-fontsize-decrease]').addEventListener(
    'click',
    event => {
      event.preventDefault();
      let fontsize = parseInt(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
      if (fontsize > 5) {
        document.body.style.fontSize = --fontsize + 'px';

        sessionStorage.setItem('fontsize', fontsize);
      }
    },
    true
  );
}

if (document.querySelector('[data-fontsize-increase]')) {
  document.querySelector('[data-fontsize-increase]').addEventListener(
    'click',
    event => {
      event.preventDefault();
      let fontsize = parseInt(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
      if (fontsize < 15) {
        document.body.style.fontSize = ++fontsize + 'px';

        sessionStorage.setItem('fontsize', fontsize);
      }
    },
    true
  );
}

/*==BT VOLTAR NOTICIAS==*/

var btVoltar = document.getElementById('bt-voltar');

if (btVoltar) {
  btVoltar.addEventListener('click', goBack);
  function goBack() {
    window.history.back();
  }
}

/*==FILTER VAGAS==*/

var filtrosVagas = document.querySelectorAll('.vagas__select');
var filtroVagaTipo = document.querySelectorAll('[data-filter-vaga="vaga"] button');
var filtroVagaLocal = document.querySelectorAll('[data-filter-vaga="local"] button');
var filtroVagaArea = document.querySelectorAll('[data-filter-vaga="area"] button');
var cardsVagas = document.querySelectorAll('.vagas__card');

if (filtroVagaTipo) {
  var filtroTipo = '';
  var filtroLocal = '';
  var filtroArea = '';

  for (var elFiltroVagaTipo of filtroVagaTipo) {
    elFiltroVagaTipo.addEventListener('click', filtrarVagasTipo);
  }

  for (var elFiltroVagaLocal of filtroVagaLocal) {
    elFiltroVagaLocal.addEventListener('click', filtrarVagasLocal);
  }

  for (var elFiltroVagaArea of filtroVagaArea) {
    elFiltroVagaArea.addEventListener('click', filtrarVagasArea);
  }
  // filtroVagaLocal.addEventListener('click', filtrarVagasLocal);
  // filtroVagaArea.addEventListener('click', filtrarVagasArea);

  // var filtros = filtroTipo + " " + filtroLocal + " " + filtroArea;

  // var cardsFiltrados = document.getElementsByClassName(filtros);
  // var cardsFiltrados = Array.from(cardsFiltrados);

  // console.log(cardsFiltrados);

  // for (var elCardVagas of cardsVagas) {
  // 	elCardVagas.classList.remove('active');
  // }

  // for (var elCardFiltrado of cardsFiltrados) {
  // 	elCardFiltrado.classList.add('active');
  // }

  function filtrarVagasTipo() {
    filtroTipo = event.target.value;

    for (var elFiltroVagaTipo of filtroVagaTipo) {
      elFiltroVagaTipo.classList.remove('active');
    }
    event.target.classList.add('active');

    if (filtroTipo == 'all-tipo') {
      filtroTipo = 'vagas__card';
    }

    var filtros = filtroTipo + ' ' + filtroLocal + ' ' + filtroArea;

    var cardsFiltrados = document.getElementsByClassName(filtros);
    var cardsFiltrados = Array.from(cardsFiltrados);

    for (var elCardVagas of cardsVagas) {
      elCardVagas.classList.remove('active');
    }

    for (var elCardFiltrado of cardsFiltrados) {
      elCardFiltrado.classList.add('active');
    }

    // console.log(filtros);
  }

  function filtrarVagasLocal() {
    filtroLocal = event.target.value;

    for (var elFiltroVagaLocal of filtroVagaLocal) {
      elFiltroVagaLocal.classList.remove('active');
    }
    event.target.classList.add('active');

    if (filtroLocal == 'all-local') {
      filtroLocal = 'vagas__card';
    }

    var filtros = filtroTipo + ' ' + filtroLocal + ' ' + filtroArea;

    var cardsFiltrados = document.getElementsByClassName(filtros);
    var cardsFiltrados = Array.from(cardsFiltrados);

    for (var elCardVagas of cardsVagas) {
      elCardVagas.classList.remove('active');
    }

    for (var elCardFiltrado of cardsFiltrados) {
      elCardFiltrado.classList.add('active');
    }

    // console.log(filtros);
  }

  function filtrarVagasArea() {
    filtroArea = event.target.value;

    for (var elFiltroVagaArea of filtroVagaArea) {
      elFiltroVagaArea.classList.remove('active');
    }
    event.target.classList.add('active');

    if (filtroArea == 'all-area') {
      filtroArea = 'vagas__card';
    }

    var filtros = filtroTipo + ' ' + filtroLocal + ' ' + filtroArea;

    var cardsFiltrados = document.getElementsByClassName(filtros);
    var cardsFiltrados = Array.from(cardsFiltrados);

    for (var elCardVagas of cardsVagas) {
      elCardVagas.classList.remove('active');
    }

    for (var elCardFiltrado of cardsFiltrados) {
      elCardFiltrado.classList.add('active');
    }
  }

  /*==ABRIR FILTROS VAGAS==*/

  var btFiltrosVagas = document.querySelectorAll('.vagas__filtros button');

  for (var elBtFiltrosVagas of btFiltrosVagas) {
    elBtFiltrosVagas.addEventListener('click', abrirVagas);

    function abrirVagas() {
      var filtroAberto = document.querySelector('[data-filter-vaga="' + event.target.value + '"]');
      var btAberto = document.querySelector('.vagas__filtros button[value="' + event.target.value + '"]');

      var aberto = filtroAberto.classList.contains('active');
      if (aberto) {
        filtroAberto.classList.remove('active');
        btAberto.classList.remove('active');
      } else {
        for (var elFiltrosVagas of filtrosVagas) {
          elFiltrosVagas.classList.remove('active');
        }
        for (var elBtFiltrosVagas of btFiltrosVagas) {
          elBtFiltrosVagas.classList.remove('active');
        }
        filtroAberto.classList.add('active');
        btAberto.classList.add('active');
      }
    }
  }
}

/*CONTATOS FOOTER */

// Fetch all the details element.
var details = document.querySelectorAll('.footer__sitemap details');

// Add the onclick listeners.
details.forEach(targetDetail => {
  targetDetail.addEventListener('click', () => {
    // Close all the details that are not targetDetail.
    details.forEach(detail => {
      if (detail !== targetDetail) {
        detail.removeAttribute('open');
      }
    });
  });
});

/*ACCORDEOPN FAQ */

// Fetch all the details element.
var detailsFaq = document.querySelectorAll('.carreiras-faq details');

// Add the onclick listeners.
detailsFaq.forEach(targetDetail => {
  targetDetail.addEventListener('click', () => {
    // Close all the details that are not targetDetail.
    detailsFaq.forEach(detail => {
      if (detail !== targetDetail) {
        detail.removeAttribute('open');
      }
    });
  });
});

var sucessoNews = document.querySelector('.newsletter .wpcf7-response-output');

if (sucessoNews) {
  sucessoNews.id = 'sucesso-newsletter-rodape';
}

var sucessoContato = document.querySelector('.newsletter .wpcf7-response-output');

if (sucessoContato) {
  sucessoContato.id = 'sucesso-meio-formulario';
}

/*==VALIDACAO TAGUEAMENTO==*/
// document.addEventListener('click', getElement);

// function getElement(){
//   console.log(event.target);
// }

var btTopo = document.getElementById('scroll-top');
if (btTopo) {
  btTopo.addEventListener('click', scrollBtTopo);
  function scrollBtTopo() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}

window.addEventListener('scroll', e => {
  window.scrollY > 20 ? document.body.classList.add('is--scrolling') : document.body.classList.remove('is--scrolling');
});

/*==MENSAGEM CONSOLE TRABALHE CONOSCO===*/

console.log('%c' + 'Venha fazer beleza com a gente:', 'font-size:20px; font-weight:bold; color: #716da4;');
console.log('%c' + 'https://www.grupoboticario.com.br/vagas/', 'font-size:20px; font-weight:bold; color: #716da4;');

/*==MODAL PÁGINA LICENÇA PARENTAL===*/

const modalCartilhaView = document.getElementById('licenca-parental__modal'),
  modalCartilhaBtn = document.getElementById('btx-download-cartilha'),
  modalCartilhaClose = document.getElementById('licenca-parental__modal-close');

if (modalCartilhaView) {
  modalCartilhaBtn.addEventListener('click', () => {
    modalCartilhaView.classList.add('active-modal');
  });

  modalCartilhaClose.addEventListener('click', () => {
    modalCartilhaView.classList.remove('active-modal');
  });
}

/*==MODAL PÁGINA FORMAÇÃO AWS===*/

const modalAceiteAws = document.getElementById('modal-aws'),
  modalAbrirAws = document.querySelectorAll('.aws__modal-open'),
  modalAceiteCloseAws = document.getElementById('aws__modal-close');

if (modalAceiteAws) {
  modalAbrirAws.forEach(modalAceite => {
    modalAceite.addEventListener('click', () => {
      modalAceiteAws.classList.add('active-modal');
    });
  });

  modalAceiteCloseAws.addEventListener('click', () => {
    modalAceiteAws.classList.remove('active-modal');
  });
}

/*==BLOCO MODAL (BOTÃO)===*/

var btAbrirBlocoModalBtn = document.querySelectorAll('.block-modal__btn');
var modalBlocoModalBtn = document.querySelectorAll('.block-modal__modal-btn');

if (btAbrirBlocoModalBtn) {
  for (var elBtAbrirBlocoModalBtn of btAbrirBlocoModalBtn) {
    elBtAbrirBlocoModalBtn.addEventListener('click', abrirBlocoModal);

    function abrirBlocoModal() {
      var nBtAbrirBlocoModalBtn = Array.prototype.indexOf.call(btAbrirBlocoModalBtn, event.target);
      var activeBlocoModal = modalBlocoModalBtn[nBtAbrirBlocoModalBtn];
      activeBlocoModal.classList.add('active-modal');
      document.body.classList.add('bloco-modal-ativo');
    }
  }

  for (var elModalBlocoModalBtn of modalBlocoModalBtn) {
    var btFecharBlocoModal = elModalBlocoModalBtn.querySelector('.bt-close');
    btFecharBlocoModal.addEventListener('click', fecharBlocoModal);

    function fecharBlocoModal() {
      for (var elModalBlocoModalBtn of modalBlocoModalBtn) {
        elModalBlocoModalBtn.classList.remove('active-modal');
      }
      document.body.classList.remove('bloco-modal-ativo');
    }
  }
}

/*==BLOCO MODAL (IMAGEM)===*/

var btAbrirBlocoModalImg = document.querySelectorAll('.block-modal__img');
var modalBlocoModalImg = document.querySelectorAll('.block-modal__modal-img');

if (btAbrirBlocoModalImg) {
  for (var elBtAbrirBlocoModalImg of btAbrirBlocoModalImg) {
    elBtAbrirBlocoModalImg.addEventListener('click', abrirBlocoModal);

    function abrirBlocoModal() {
      var nBtAbrirBlocoModalImg = Array.prototype.indexOf.call(btAbrirBlocoModalImg, event.target);
      nBtAbrirBlocoModalImg = nBtAbrirBlocoModalImg / 2;
      var activeBlocoModal = this.parentNode.lastElementChild;
      activeBlocoModal.classList.add('active-modal');
      document.body.classList.add('bloco-modal-ativo');
    }
  }

  for (var elModalBlocoModalImg of modalBlocoModalImg) {
    var btFecharBlocoModal = elModalBlocoModalImg.querySelector('.bt-close');
    btFecharBlocoModal.addEventListener('click', fecharBlocoModal);

    function fecharBlocoModal() {
      for (var elModalBlocoModalImg of modalBlocoModalImg) {
        elModalBlocoModalImg.classList.remove('active-modal');
      }
      document.body.classList.remove('bloco-modal-ativo');
    }
  }
}

/*==VIDEO LIBRAS===*/

if (document.querySelector('.video-libras__video')) {
  var videoLibras = document.getElementById('videoLibras');
  var fecharLibras = document.getElementById('fecharLibras');
  const videoLibrasToggle = document.querySelector('.a11y__toggle--video');

  if (videoLibras) {
    videoLibrasToggle.addEventListener('click', abrirVideoLibras);
    function abrirVideoLibras() {
      videoLibras.classList.toggle('show');
      fecharLibras.addEventListener('click', fecharVideoLibras);
      function fecharVideoLibras() {
        videoLibras.classList.remove('show');
      }
    }
  }
}

function videoDefer() {
  var vidDefer = document.getElementsByTagName('iframe');

  // console.log("iFrames: ", vidDefer);
  for (var i = 0; i < vidDefer.length; i++) {
    var videoContainer = vidDefer[i].closest('.video-wrapper');

    if (vidDefer[i].getAttribute('data-src')) {
      vidDefer[i].setAttribute('src', vidDefer[i].getAttribute('data-src'));

      if (videoContainer) {
        vidDefer[i].closest('.video-wrapper').classList.add('loaded');
      }
    }
  }
}

window.addEventListener('load', function () {
  setTimeout(function () {
    videoDefer();
  }, 1000);
});

/*==PAG B2B==*/
var b2bItems = document.querySelectorAll('.b2b__item');

for (var elB2bItem of b2bItems) {
  elB2bItem.addEventListener('click', abrirItem);
}

function abrirItem() {
  // for (var elB2bItem of b2bItems) {
  //   elB2bItem.classList.remove('details--active');
  // }

  var itemClicado = event.target.closest('.b2b__item');
  itemClicado.classList.toggle('details--active');
}

const documentLang = document.documentElement.lang
const btnLangPTBR = document.getElementById('btx-portugues-topo')
const btnLangPTPT = document.getElementById('btx-portugues-pt-topo')
const btnLangEN = document.getElementById('btx-ingles-topo')
const btnLangES = document.getElementById('btx-espanhol-topo')
if (documentLang === 'pt') {
  btnLangPTBR.classList.add('selected')
  btnLangEN.classList.remove('selected')
  btnLangES.classList.remove('selected')
}
if (documentLang === 'en') {
  btnLangPTBR.classList.remove('selected')
  btnLangPTPT.classList.remove('selected')
  btnLangEN.classList.add('selected')
  btnLangES.classList.remove('selected')
}
if (documentLang === 'es') {
  btnLangPTBR.classList.remove('selected')
  btnLangPTPT.classList.remove('selected')
  btnLangEN.classList.remove('selected')
  btnLangES.classList.add('selected')
}
if (documentLang === 'pt-pt') {
  btnLangPTPT.classList.add('selected')
  btnLangEN.classList.remove('selected')
  btnLangES.classList.remove('selected')
}

var wpcf7Elm = document.querySelector('#form-aceleracaostartups .wpcf7')
var btnAceleracaoStartups = document.getElementById('btx-form-aceleracaostartups')
var formAceleracaoStartupStartup = document.querySelector('#form-aceleracaostartups #form-aceleracaostartups__input--startup input')
var formAceleracaoStartupNome = document.querySelector('#form-aceleracaostartups #form-aceleracaostartups__input--nome input')
var formAceleracaoStartupEmail = document.querySelector('#form-aceleracaostartups #form-aceleracaostartups__input--email input')

if (wpcf7Elm) {
  wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
    // window.open('https://dgbinst.wpengine.com/aceleracao-de-startups-cadastro', '_blank').focus()
    var linkFormAceleracao = document.querySelector('#form-aceleracaostartups .form-aceleracaostartups__grid')
    linkFormAceleracao.classList.add('teste')
    linkFormAceleracao.insertAdjacentHTML('afterend', '<p class=\'segundo-form\'>Sua inscrição inicial foi realizada com sucesso. Para continuar a inscrição, clique <a href=\'https://dgbinst.wpengine.com/aceleracao-de-startups-cadastro\' target=\'__blank\'>aqui</a>.</p>')
  }, false);
  // console.log(formAceleracaoStartupEmail)
  // console.log(formAceleracaoStartupNome)
  // console.log(formAceleracaoStartupStartup)

  btnAceleracaoStartups.addEventListener('click', () => {
    if ((formAceleracaoStartupEmail && formAceleracaoStartupEmail.value) || (formAceleracaoStartupNome && formAceleracaoStartupNome.value) || (formAceleracaoStartupStartup && formAceleracaoStartupStartup.value))
      window.open('https://grupoboticario.com.br/aceleracao-de-startups-cadastro', '_blank').focus()
  })
}

// menu flutuante 2, quando ativo
document.addEventListener('DOMContentLoaded', function () {
  var pageTitle = document.querySelector('.page-heading__title h1').textContent.trim().toLowerCase();

  var menuLinks = document.querySelectorAll('.menu-flutuante2 ul li a');

  menuLinks.forEach(function (link) {
    var linkText = link.textContent.trim().toLowerCase();

    if (linkText === pageTitle) {
      var currentLi = link.closest('li');
      link.classList.add('ativo');
      currentLi.style.borderBottom = '1px solid #fff';

      var menuContainer = document.querySelector('.menu-flutuante2 ul');
      var liOffset = currentLi.offsetLeft;
      var liWidth = currentLi.offsetWidth;
      var menuWidth = menuContainer.offsetWidth;

      menuContainer.scrollTo({
        left: liOffset - (menuWidth / 2) + (liWidth / 2),
        behavior: 'smooth',
      });
    }
  });
});
